<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" userSettings>
          <v-card :loading="loading">
            <v-card-title primary-title :class="`${arabic?'arFont':'enFont'} pa-4 font-weight-bold primary white--text`">
              {{i18n.userSettings}}
              <v-spacer></v-spacer>
              <v-btn color="success" depressed @click="userPanel=!userPanel">
                <v-icon v-if="!userPanel">expand_more</v-icon>
                <v-icon v-else>expand_less</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text v-if="userPanel" class="px-3">
              <v-row class="pa-0">
                <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-4`" style="font-size:16px;line-height:2;">
                  <v-row class="pa-0 align-center">
                    <v-col cols="12">
                      <v-switch 
                        :label="i18n.getEmailNotifications" :class="`${arabic?'arFont':'enFont'}`" inset v-model="userMe.email_notifications">
                      </v-switch>
                      <v-switch 
                        :label="i18n.getReportsByEmail" :class="`${arabic?'arFont':'enFont'}`" inset v-model="userMe.email_reports">
                      </v-switch>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions v-if="userPanel">
              <v-spacer></v-spacer>
              <span :class="`${arabic?'arFont':'enFont'} error--text`">{{ i18n[error] }}</span>
              <v-spacer></v-spacer>
              <v-btn 
                depressed
                color="primary"
                :loading="loading"
                :disabled="loading || !settings.message || !settings.mission || !settings.vision"
                :class="`${arabic?'arFont':'enFont'}`"
                @click="saveUserSettings()"
              >{{i18n.saveSetting}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  data() {
    return {
      rules: {
        hundred: value => value <= 100 || this.i18n['hundredError'],
        required: value => !!value || this.i18n['required'],
      },
      loading:false,
      userPanel:false,
      userMe:null,
      error:null,
      errorTimeOUt:null,
    }
  },
  
  methods: {
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    genKey(type){
      let a = `MCIT_${type}_${randomString(12, 'aA#')}`
      return a
    },
    goTo(path) {
      this.$router.push(path)
    },
    resetError(){
      clearTimeout(this.errorTimeOUt)
      this.errorTimeOUt = setTimeout(x=>{ this.error = null }, 4000)
    },
    async loadUserSettings(){
      this.loading = true
      let a = await this.$store.dispatch('getUser')
      this.userMe = a
      this.loading = false
    },
    async saveUserSettings(){
      this.loading = true
      await this.$store.dispatch('updateUser', this.userMe)
      this.loading = false
      this.$emit('snackbarNotification', `${this.i18n['success']}`, 'success')
      this.loadUserSettings()
    }
    
  },
  watch:{
    getSettings(){},

  },
  computed:{
    site(){
      return this.$store.state.site
    },
    access(){
      let user = {...this.$store.state.user}
      let role = user.role
      let menu = this.$store.state.modelMenu
      let main = menu.filter(x => !x.subs)
      let subs = [].concat(...menu.filter(x => x.subs).map(x => x.subs))
      let all = main.concat(subs)
      let c = all.filter(x=>x.text == this.$route.name)[0]
      let a = c.roles.includes(role)
      return a
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    org(){
      return this.$store.state.org
    },
    getSettings(){
      this.settings = this.$store.state.settings
      return this.$store.state.settings
    },
    userRoles(){
      return this.$store.state.userRoles
    },
    usersLevels(){
      return this.$store.state.usersLevels
    },
    api(){
      return this.$store.state.settings.apiBase
    }
  },
  created(){
    this.loadUserSettings()
  },
  
}
</script>

<style>
.vline {
  max-width: 1px;
  min-height: 19px;
  background: #c2c2c2;
  position: relative;
  top: -19px;
}
.vdesc {
  position: relative;
  top: -36px;
  max-width: 30px;
  font-size: 10px;
  max-height: 0;
  white-space: nowrap;
}
</style>